import React from 'react';
import { Users } from 'lucide-react';
import { Particles } from '@/components/ui/particles';

const PersonaHeader: React.FC = () => {
  return (
    <div className="-mx-6 -mt-8 relative overflow-hidden bg-gradient-to-br from-violet-700 via-indigo-700 to-blue-800 text-white">
      <Particles
        className="absolute inset-0"
        quantity={80}
        ease={70}
        color="#ffffff"
        size={0.45}
        staticity={40}
      />

      {/* Decorative ambient blobs */}
      <div className="absolute -top-32 -right-24 w-[28rem] h-[28rem] bg-purple-400/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-blue-300/15 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[14rem] bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-9 h-9 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20">
            <Users className="w-4 h-4 text-white" />
          </div>
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-white/55">
            Training Library
          </span>
        </div>

        <h1 className="text-5xl md:text-6xl font-bold tracking-tight mb-4 leading-[1.1]">
          Personas
        </h1>

        <p className="text-lg text-white/70 max-w-lg leading-relaxed">
          Master your skills through immersive scenarios with real-world personalities and challenges.
        </p>
      </div>
    </div>
  );
};

export default PersonaHeader;
